import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';
import { WorkFlow } from "src/app/enum/water-lab/workFlow";
import { AccessUserInfo, LabResult, LabelSummary, PrintLabelSummary, UserDetail } from 'src/app/models';
import { ShippingManifestData, TASK } from 'src/app/models/water-lab/shipping-manifest';
import { CustomDatePipe } from 'src/app/pipes';
import { LabRequisitionService, MessageService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'bart-preview-label',
  templateUrl: './preview-label.component.html',
  styleUrls: ['./preview-label.component.scss'],
  providers:[CustomDatePipe]
})
export class PreviewLabelComponent implements OnInit {

 
  requisitionColumnHeader: any = [];
  activeLabelSummaryTestList: LabelSummary[];
  inActiveLabelSummaryTestList: LabelSummary[];
  printLabelSummaryResponse: PrintLabelSummary[] = []
  first = 0;
  rows = 10;
  facilityDetails: any;
  pageCount: number=0;
  labelCount:number=0;
  containerCount:number=0;
  requisitionCount:number=0
  isPrintLabels: boolean = false;
  isPrintManifest: boolean = false;
  labRequestIds: string;
  labRequisitionIds: string;
  facilityMasterId: number;
  public userInfo: UserDetail;
  workFlow:string;
  facilityDisplayName:string;
  isOpenFromPendingManifest:boolean=false;
  selectedPendingManifestRow:ShippingManifestData[]=[];
  drawDate:Date=null;
  drawDateMin:Date;
  drawDateMax:Date;
  btnCreateRequisitionLabel:string="Create Requisition & Print Labels";
  btnCreateRequisition:string="Create Requisition";
  isReDraw:boolean=false;
  selectedPrinter:string="network";
  public ENUM_WORKFLOW = WorkFlow;
  TASK = TASK;
  completedTask: string[] = [];
  hasPrintLabelTaskCompleted = false;
  constructor
    (
      private _labRequisitionService: LabRequisitionService,
      private _loaderService: LoaderService,
      private dynamicConfig: DynamicDialogConfig,
      private _dynamicDialogRef: DynamicDialogRef,
      private _userService: UserService,
      private messageService: MessageService,
      private customDatePipe :CustomDatePipe,
    ) 
    {
    
    }

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.requisitionColumnHeader =
      [
        { field: 'ModelNumber', header: 'Model #', display: 'table-cell', width: "18%" },
        { field: 'EquipmentSerialNumber', header: 'Serial #', display: 'table-cell', width: "10%" },
        { field: 'LabRequestID', header: 'Request ID', display: 'table-cell', width: "10%" },
        { field: 'TestDisplayName', header: 'Test ID | Name', display: 'table-cell', width: "20%" },
        { field: 'ContainerID', header: 'Container ID', display: 'table-cell', width: "10%" },
        { field: 'ContainerDescription', header: 'Container Description', display: 'table-cell', width: "32%" },
      ];
      
    this.facilityMasterId = this.dynamicConfig.data.facilityMasterId
    this.workFlow = this.dynamicConfig.data.workFlow;
    this.facilityDisplayName=this.dynamicConfig.data.facilityDisplayName;
    this.isOpenFromPendingManifest=this.dynamicConfig.data.isFromPendingManifest;
    this.isReDraw=this.dynamicConfig.data.isReDraw;
    if(this.isOpenFromPendingManifest)
      {
        let printLabelColumn= { field: 'RequisitionNumber', header: 'Requisition ID', display: 'table-cell', width: "15%" }
        this.requisitionColumnHeader.splice(3, 0, printLabelColumn)
        this.requisitionColumnHeader=this.requisitionColumnHeader.filter(x=>x.field!="ContainerDescription");
      }
    this.getFacilityDetails(this.facilityMasterId)
    if(this.isOpenFromPendingManifest)
    {
      this.labRequisitionIds=this.dynamicConfig.data.labRequisitionId;
      this.selectedPendingManifestRow=this.dynamicConfig.data.selectedRows;
      this.loadPrintLabelSummary(this.labRequisitionIds)
    }
    else if(this.isReDraw)
    {
      this.labRequisitionIds=this.dynamicConfig.data.labRequisitionId
      this.loadPrintLabelSummary(this.labRequisitionIds); 
      this.setMin_MaxDrawDate(this.workFlow);
    }
    else
    {
      this.labRequestIds = this.dynamicConfig.data.labRequestId
      this.loadLabelSummary(this.labRequestIds)
      this.setMin_MaxDrawDate(this.workFlow);
    }
    //Start:Commented in PCR-31 on 08-Jan-2023
    // if(this.workFlow==this.ENUM_WORKFLOW.ACUTE){
    //   this.selectedPrinter="zebra";
    // }
    //End:Commented in PCR-31 on 08-Jan-2023
   
  }
  loadLabelSummary(labRequestIds) {
    this._loaderService.show();
    let getLabelSummaryParam = {
      "GETLABELSUMMARY": {
        "LabRequestID": labRequestIds
      }
    }
    this._labRequisitionService.getLabelSummary(JSON.stringify(getLabelSummaryParam)).subscribe(data => {
      let labelSummary = data.labelSummary;
      if (labelSummary) 
      {
        this.activeLabelSummaryTestList = labelSummary.filter(x => x.TestStatus == 'active' && !x.ProfileInactiveTests)
        //Start:Filter Distinct Inactive Tests
        this.inActiveLabelSummaryTestList = labelSummary.filter
        (
          (item, i, arr) => (item.TestStatus != 'active' || item.ProfileInactiveTests) && arr.findIndex(t => t.TestDisplayName === item.TestDisplayName) === i
        );
        //End
        this.labelCount=this.activeLabelSummaryTestList.length;
        this.requisitionCount=this.activeLabelSummaryTestList.filter(x=>x.IsSWAB==false).length
        this.containerCount=this.labelCount;
        //Start:PCR-007.1: Lab NEW Requirement - Lab New Profile Code 0386 [FREQ-774268] 
        let isSpecialEdgeCaseCount=this.activeLabelSummaryTestList.filter(x=>x.TestDisplayName.startsWith("0386 |")|| x.TestDisplayName.startsWith("0387 |")).length;
        if(isSpecialEdgeCaseCount>0)
        {
          this.containerCount=this.containerCount+isSpecialEdgeCaseCount;
        }
        //End:PCR-007.1: Lab NEW Requirement - Lab New Profile Code 0386 [FREQ-774268] 
        let count = this.activeLabelSummaryTestList.length / 8;
        this.pageCount = Math.ceil(count);
        //Remove Item from grid if it is Swab=false
        this.activeLabelSummaryTestList = this.activeLabelSummaryTestList.filter(x=>x.IsSWAB==false)
        
      }
      this._loaderService.hide()
    },
      err => {
        this._loaderService.hide()
      });

  }
  getFacilityDetails(id) {
    let getFacilityParam = {
      "GETFACILITYINFO": {
        "facilityMasterId": id
      }
    }
    this._labRequisitionService.getfacilityDetails(JSON.stringify(getFacilityParam)).subscribe(data => {
      this.facilityDetails = data[0];
      this._loaderService.hide()
    },
      err => {
        this._loaderService.hide()
      });

  }
  closePopup() {
    let value =this.isOpenFromPendingManifest?this.dynamicConfig.data.labRequisitionId:this.dynamicConfig.data.labRequestId;
    let key = this.isOpenFromPendingManifest?'LabRequisitionId':'LabRequestId';
    this._dynamicDialogRef.destroy();
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LABEL_SUMMARY,
      screenPath: location.pathname,
      key: key,
      value: value,
      eventDescription:UserActionDescription.LABEL_SUMMARY_CANCELED_CLICKED
    });
    //#endregion

  }

  createLabRequisitions(btnLable:string) 
  {
    this._loaderService.show();
    let calenderDate=this.customDatePipe.transform(this.drawDate,"calendar")
    if(calenderDate==this.customDatePipe.transform(new Date(),"calendar"))
    {
      calenderDate=this.customDatePipe.transform(new Date(),"calendar","MM/dd/yyyy HH:mm");
    }
    let utcDrawDate= this.customDatePipe.transform(calenderDate,"UTC");
    let CreateLabRequisitionParam = 
    {
      "CREATELABREQUISITION": {
        "LabRequestID": this.labRequestIds,
        "UserName": this.userInfo.userName,
        "DrawDate":this.workFlow==this.ENUM_WORKFLOW.HOME?utcDrawDate:null,
        "IsPrintLabel":false//btnLable =="Create Requisition"?false:true //Changes made on 21-July-2023 for Zebra printer changes if print not suceess it will not update print Label date
      }
    }
   //Start: redraw lab result Param
    let redrawLabResultParam = 
    {
      "REDRAWLABRESULT": {
        "LabRequisitionID": this.labRequisitionIds,
        "UserName": this.userInfo.userName,
        "DrawDate":this.workFlow==this.ENUM_WORKFLOW.HOME?utcDrawDate:null,
        "IsPrintLabel":false//btnLable =="Create Requisition"?false:true //Changes made on 21-July-2023 for Zebra printer changes if print not suceess it will not update print Label date
      }
    }
    //End: redraw lab result Param
    let objParam:any=CreateLabRequisitionParam;
    if(this.isReDraw)
    {
      objParam=redrawLabResultParam;
    }

    this._labRequisitionService.createLabRequisition(JSON.stringify(objParam),this.isReDraw).subscribe(data => {
      if (data.printLabelSummary) 
      {
        this.printLabelSummaryResponse = data.printLabelSummary;
        if (data.printLabelSummary.length>0)
        {
          if(btnLable !=="Create Requisition"){
            this.isPrintLabels = true;
            this.labRequisitionIds=this.printLabelSummaryResponse.map(item => item.LabRequisitionID).join()
            if(this.ENUM_WORKFLOW.HOME==this.workFlow)
            {
              this.isPrintManifest=true;
            }
          }  
          else{
            this._loaderService.hide()
            this._dynamicDialogRef.close(true);
          }
          if(this.isReDraw)   {
            let redrawData:LabResult= this.dynamicConfig.data.selectedRows;
            redrawData.ReDrawStatus="Pending"
            redrawData.IsRedraw=false
          }
        }
        else
        {
          this.messageService.showAlertMessage("Error:Some Error Occured. You may reach out to your administrator.");
          this._loaderService.hide();
        }
      }
      if (data.errors) {
        console.log("createLabRequisition-Error:"+data.errors);
        this._loaderService.hide();
      }
    })
    let UsrActionDescriptionForPrint=null;
    if(btnLable !=="Create Requisition")
    {
     UsrActionDescriptionForPrint =this.workFlow==this.ENUM_WORKFLOW.HOME?UserActionDescription.LABEL_SUMMARY_CREATE_REQUISITION_AND_PRINT_LABELS_PRINT_HOME_MANIFEST_CLICKED:UserActionDescription.LABEL_SUMMARY_CREATE_REQUISITION_AND_PRINT_LABELS_CLICKED
    }
    else
    {
      UsrActionDescriptionForPrint = UserActionDescription.LABEL_SUMMARY_CREATE_REQUISITION_CLICKED
    }
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LABEL_SUMMARY,
      screenPath: location.pathname,
      key: 'LabRequestID',
      value: this.labRequestIds,
      eventDescription:UsrActionDescriptionForPrint
    });
    //#endregion

  }


  paginate(event) {

   //#region User Action Audit
   this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.PAGE_CHANGED,
    screenName: ScreenName.LABEL_SUMMARY,
    screenPath: location.pathname,
    key: 'Selected_Page_No',
    value: (event.first / event.rows) + 1,
    eventDescription:UserActionDescription.LABEL_SUMMARY_PAGE_NO_CLICKED
  });
  //#endregion
  }
  printLabelPDFCompleted(isSuccess)
  {
    this._loaderService.hide()
    if(isSuccess)
    {
      this.upDatePrintLabelDate(()=>
      {
        this._dynamicDialogRef.close({result:true,isSuccess:isSuccess});
      });
    }
    else
    {
      this._dynamicDialogRef.close({result:true,isSuccess:isSuccess});
    }
  }
  printPDFLoaded()
  {
    this._loaderService.hide()
    this._dynamicDialogRef.close(true);
  }
  // Start:Code if poup open from pending manifest
  loadPrintLabelSummary(labRequisionId) {
    this._loaderService.show();
    let printLabelSummaryParam = {
      "PRINTLABELSUMMARY": {
        "LabRequisitionID": labRequisionId
      }
    }
    this._labRequisitionService.printLabelSummary(JSON.stringify(printLabelSummaryParam)).subscribe(data => {
      let printLabelSummary = data.printLabelSummary;
      this.printLabelSummaryResponse=data.printLabelSummary;
      if (printLabelSummary) 
      {
        this.activeLabelSummaryTestList = printLabelSummary
        this.labelCount=this.activeLabelSummaryTestList.length;
        this.requisitionCount=this.activeLabelSummaryTestList.filter(x=>x.IsSWAB==false).length
        this.containerCount=this.labelCount;
        //Start:PCR-007.1: Lab NEW Requirement - Lab New Profile Code 0386 [FREQ-774268] 
        let isSpecialEdgeCaseCount=this.activeLabelSummaryTestList.filter(x=>x.TestDisplayName.startsWith("0386 |")|| x.TestDisplayName.startsWith("0387 |")).length;
        if(isSpecialEdgeCaseCount>0)
        {
          this.containerCount=this.containerCount+isSpecialEdgeCaseCount;
        }
        //End:PCR-007.1: Lab NEW Requirement - Lab New Profile Code 0386 [FREQ-774268] 
        let count = this.activeLabelSummaryTestList.length / 8;
        this.pageCount = Math.ceil(count);
        this.activeLabelSummaryTestList = this.activeLabelSummaryTestList.filter(x=>x.IsSWAB==false)
      }
      this._loaderService.hide()
    },
    err => 
    {
        this._loaderService.hide()
    });
  }
  printButtonClicked()
  {
    this._loaderService.show();
    this.isPrintLabels = true;
     //#region User Action Audit    
    let value =this.isOpenFromPendingManifest?this.dynamicConfig.data.labRequisitionId:this.dynamicConfig.data.labRequestId;
    let key = this.isOpenFromPendingManifest?'LabRequisitionId':'LabRequestId';
    let UsrActionDescriptionForAtHome :any = null;
    if(this.workFlow==this.ENUM_WORKFLOW.HOME && this.isOpenFromPendingManifest)
    {
      UsrActionDescriptionForAtHome = UserActionDescription.SHIPPING_MANIFEST_PENDING_PRINT_HOME_LABEL_SUMMARY_PRINT_CLICKED
    }
    else
    {
      UsrActionDescriptionForAtHome = UserActionDescription.SHIPPING_MANIFEST_PENDING_PRINT_LABEL_SUMMARY_PRINT_CLICKED
    }
    let UsrActionDescription = this.isOpenFromPendingManifest?UsrActionDescriptionForAtHome:UserActionDescription.LABEL_SUMMARY_CREATE_REQUISITION_AND_PRINT_LABELS_CLICKED;

    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: key,
      value: value,
      eventDescription:UsrActionDescription
    });
    //#endregion
  }
  // End:Code if poup open from pending manifest
  setMin_MaxDrawDate(strWorkFlow:string)
  {
    this.drawDate=null;
    if(this.ENUM_WORKFLOW.HOME==strWorkFlow)
    {
      this.btnCreateRequisitionLabel="Create Requisition | Print Labels | Print Home Manifest"
      this.drawDate=new Date()
      this.drawDateMin = new Date();
      this.drawDateMax = new Date(new Date().setDate(new Date().getDate()+29))
    }
  }

  upDatePrintLabelDate(fnCallBack)
  {
    this._loaderService.show();
    let updatePrintLabelDateParam = {
      "UPDATEREQUISITIONPRINTLABELDATE": {
        "LabRequisitionID": this.labRequisitionIds,
        "UserName":this.userInfo.userName
      }
    }
    this._labRequisitionService.updatePrintLabelDate(JSON.stringify(updatePrintLabelDateParam)).subscribe(data => 
    {
      this._loaderService.hide()
      this.selectedPendingManifestRow.forEach(item=>
        {
          item.PrintLabelDate=this.customDatePipe.transform(data.result[0].PrintLabelDate,"local","MM/dd/yyyy HH:mm");
          item.PrintLabelDateSort=new Date (this.customDatePipe.transform(data.result[0].PrintLabelDate,"local","MM/dd/yyyy HH:mm"))
        })
        fnCallBack();
    },
    err => 
    {
        this._loaderService.hide()
        fnCallBack();
    });
  }
  validatePrinter_CreateRequisition(btnLabelText:string)
  {
    if(this.ENUM_WORKFLOW.HOME==this.workFlow && this.selectedPrinter=="zebra")
    {
      this._loaderService.show();
      let  objParams={
        "userHostAddress":this.userInfo.userHostAddress,
        "printerShareName": this.userInfo.printerShareName
      }
      this._labRequisitionService.isZebraPrinterAvailable(JSON.stringify(objParams)).subscribe(resp => {
        if(resp && resp.isZebraPrinterAvailable)
        {
          this.createLabRequisitions(btnLabelText);
        }
        else
        {
          let errMessage="Printer is not available. Please try again when printer is available.";
          this.messageService.genericConfirm({
           message: errMessage,
           header: "Alert",
           acceptLabel: "OK",
           rejectVisible:false,
           key:"HideReject"
         },        
         () => {
           this._loaderService.hide();
         });
        }
      },
      err => {
        this._loaderService.hide()
      });
    }
    else{
      this.createLabRequisitions(btnLabelText);
    }
  }
  
  /**
   * Check if all required tasks are completed and handles the event accordingly.
   * @param  {boolean} event
   * @param  {string} currentTask
   * @returns void
   */
  checkTaskCompletion(event: boolean, currentTask: string): void {
    this.hasPrintLabelTaskCompleted=typeof event === 'boolean' ? event: this.hasPrintLabelTaskCompleted;  
    const requiredTask = [TASK.PRINT_LABEL, TASK.PRINT_MANIFEST];
    this.completedTask.push(currentTask);

    const areAllTasksCompleted = requiredTask.every((task) =>
      this.completedTask.includes(task)
    );

    if (areAllTasksCompleted && this.isPrintLabels && this.isPrintManifest) {
      this.printLabelPDFCompleted(this.hasPrintLabelTaskCompleted);
      this.printPDFLoaded();
    }
    if (
      this.completedTask.includes(TASK.PRINT_LABEL) &&
      this.isPrintLabels &&
      !this.isPrintManifest
    ) {
      this.printLabelPDFCompleted(this.hasPrintLabelTaskCompleted);
    }
    if (
      this.completedTask.includes(TASK.PRINT_MANIFEST) &&
      !this.isPrintLabels &&
      this.isPrintManifest
    ) {
      this.printPDFLoaded();
    }
  }

}

